module.exports = __webpack_public_path__ + "img/bg.d420ee1f.jpg";